module.exports = __webpack_public_path__ + "static/media/auto-cart.be1af1d3.jpg";